import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  XIcon,
} from "react-share"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { useLocation } from "@reach/router"
import { contentExists } from "../utils/ug-utils"
import classNames from "classnames"

import "../styles/shareLinks.scss"

const ShareLinks = ({ title, body, url, mini, iconFillColor, bgStyle }) => {
  const location = useLocation()
  const iconStyle = contentExists(iconFillColor)
    ? { size: 64, round: true, iconFillColor: iconFillColor, bgStyle: bgStyle }
    : { size: 64, round: true, iconFillColor: "white", bgStyle: { fill: "black" } }
  const copyLinkBackground = iconStyle?.bgStyle?.fill ?? "black"
  const shareLinkProps = { url: url ? url : location.href }

  const header =
    contentExists(title) || contentExists(body) ? (
      <div className="share-links-header">
        {contentExists(title) && <h3 className="share-links-title">{title}</h3>}
        {contentExists(body) && <div className="share-links-body">{body}</div>}
      </div>
    ) : null

  return (
    <div className={classNames("share-links-container", { mini: mini })}>
      {header}
      <div className="share-links m-auto px-sm-5 d-flex justify-content-between align-items-center">
        <TwitterShareButton {...shareLinkProps} aria-label="Share on Twitter">
          <XIcon {...iconStyle} />
        </TwitterShareButton>
        <FacebookShareButton {...shareLinkProps} aria-label="Share on Facebook">
          <FacebookIcon {...iconStyle} />
        </FacebookShareButton>
        <LinkedinShareButton {...shareLinkProps} aria-label="Share on LinkedIn">
          <LinkedinIcon {...iconStyle} />
        </LinkedinShareButton>
        <EmailShareButton {...shareLinkProps} aria-label="Share by Email">
          <EmailIcon {...iconStyle} />
        </EmailShareButton>
        <CopyToClipboard text={mini ? location.origin + shareLinkProps.url : location.href} title="Copy link">
          <button
            aria-label="share"
            className="react-share__ShareButton copy-link"
            style={{
              background: copyLinkBackground,
              border: "none",
              borderRadius: iconStyle?.size ? `${iconStyle.size}px` : undefined,
              padding: 0,
              font: "inherit",
              color: "inherit",
              cursor: "pointer",
            }}
          >
            <i
              className="fas fa-link"
              style={{
                verticalAlign: "middle",
                color: iconStyle.iconFillColor,
                fontWeight: 400
              }}
              aria-hidden="true"
            />
          </button>
        </CopyToClipboard>
      </div>
    </div>
  )
}

ShareLinks.propTypes = {
  title: PropTypes.string,
  body: PropTypes.any,
  url: PropTypes.string,
  mini: PropTypes.bool,
}

ShareLinks.defaultProps = {
  title: "",
  body: "",
  url: null,
  mini: false,
}

export default ShareLinks

export const fragment = graphql`
  fragment ParagraphShareLinks on paragraph__share_links {
    drupal_id
    field_share_links_title
    field_share_links_body {
      processed
    }
  }
`
